<template>
  <div
    v-if="isActive"
    id="grab"
    ref="launcher"
    key="grab"
    class="intercom-draggable"
    :style="{
      position: 'fixed',
      top: position.y + 'px',
      left: position.x + 'px',
      zIndex: 9999,
      cursor: 'grab',
      width: '60px',
      height: '60px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }"
    @click="handleClick"
  >
    <div
      class="intercom-launcher"
      :style="launcherStyle"
      role="button"
      tabindex="0"
      aria-label="Open Intercom Messenger"
    >
      <component
        :is="isOpen ? MinimizeIcon : OpenIcon"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useDraggable } from '@vueuse/core';
import { hide } from '@intercom/messenger-js-sdk';
import { showIntercom } from '@/lib/intercom-helper';

import OpenIcon from './OpenIcon.vue';
import MinimizeIcon from './MinimizeIcon.vue';

const launcher = ref(null);
const isOpen = ref(false);
const isActive = ref(true);
const isDragging = ref(false);
const intercomPosition = JSON.parse(localStorage.getItem('intercom-position'));
const dragStart = ref({ x: intercomPosition?.x || 0, y: intercomPosition?.y || 0 });

onMounted(() => {
  document.addEventListener('intercom-opened', () => (isOpen.value = true));
  document.addEventListener('intercom-closed', () => (isOpen.value = false));
});

const handleClick = (e) => {
  if (isDragging.value) {
    e.stopPropagation();
    return;
  }

  if (isOpen.value) {
    hide();
  } else {
    showIntercom('widget');
  }
};

useDraggable(launcher, {
  initialValue: { x: 0, y: 0 },
  transform: false,
});

const launcherStyle = {
  background: 'rgb(152, 42, 134)',
  borderRadius: '50%',
  padding: '5px',
  width: '50px',
  height: '50px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const defaultPosition = {
  x: window.innerWidth - 100,
  y: window.innerHeight - 150,
};

const savedPosition = JSON.parse(localStorage.getItem('intercom-position'));
const initialPosition = savedPosition ?? defaultPosition;

const { position } = useDraggable(launcher, {
  initialValue: initialPosition,
  transform: false,
  onStart: (_, event) => {
    dragStart.value = { x: event.clientX, y: event.clientY };
  },
  onMove: (_, event) => {
    const dx = event.clientX - dragStart.value.x;
    const dy = event.clientY - dragStart.value.y;
    const distance = Math.sqrt(dx * dx + dy * dy);
    if (distance > 5) {
      isDragging.value = true;
    }
  },
  onEnd: () => {
    setTimeout(() => {
      isDragging.value = false;
    }, 100);
    localStorage.setItem('intercom-position', JSON.stringify(position.value));
  },
});

</script>
